module.exports = __webpack_public_path__ + "img/sup_withdraw_mtpay2.edaa8550.jpg";